import { Button } from '@dfh-corp-sites/ui'
import { cn } from '@dfh-corp-sites/ui/utils'
import React from 'react'

import { useDispensaryContext } from '../../../lib/dispensaries'
import Link from '../../global/Link'

const DFHStoryDispensary: React.FC = () => {
  const dispensaryContext = useDispensaryContext()
  const dispensarySlug = dispensaryContext?.slug || ''

  const getPath = (path: string) => {
    const isDispensary = !!dispensaryContext
    return isDispensary ? `/u/${dispensarySlug}${path}` : path
  }

  return (
    <div className={cn('max-w-[1280px] mx-auto py-6 px-10', 'md:py-20')}>
      <div className="flex items-center justify-between gap-4">
        <h2 className={cn('text-brand-navy text-2xl leading-[120%] font-medium', 'md:text-5xl')}>
          Science Meets Wellness
        </h2>

        <Button size="sm" className="hidden md:block" asChild>
          <Link to={getPath('/our-story')}>Our Story</Link>
        </Button>
      </div>

      <p
        className={cn(
          'text-base text-brand-navy leading-[130%] font-light mt-6 max-w-[1000px]',
          'md:text-[40px]',
        )}
      >
        Designs for Health has led the way in functional medicine for over three decades—innovating,
        educating, and delivering results.
      </p>

      <Button size="sm" className="block md:hidden mt-8 w-[130px] text-center" asChild>
        <Link to={getPath('/our-story')}>Our Story</Link>
      </Button>
    </div>
  )
}

export default DFHStoryDispensary
